"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncState = void 0;
var AsyncState;
(function (AsyncState) {
    AsyncState[AsyncState["Idle"] = 1] = "Idle";
    AsyncState[AsyncState["Pending"] = 2] = "Pending";
    AsyncState[AsyncState["Resolved"] = 3] = "Resolved";
    AsyncState[AsyncState["Processing"] = 4] = "Processing";
    AsyncState[AsyncState["Rejected"] = 5] = "Rejected";
})(AsyncState = exports.AsyncState || (exports.AsyncState = {}));
//# sourceMappingURL=AsyncState.js.map